import { attach } from 'effector'

import { api } from '@setplex/tria-api'

// VODS
export const getVodBundleInfoFx = attach({
  effect: api.vodBundles.getVodBundleInfoBaseFx,
})
export const getVodFx = attach({
  effect: api.vods.getVodBaseFx,
})

// TV
export const getTvBundleInfoFx = attach({
  effect: api.tvBundles.getTvBundleInfoBaseFx,
})
export const getTvChannelsByIdFx = attach({
  effect: api.tv.getTvChannelsByIdBaseFx,
})

// TV SHOWS
export const getShowBundleInfoFx = attach({
  effect: api.showBundles.getShowBundleInfoBaseFx,
})
export const getTvShowBaseFx = attach({
  effect: api.tvshows.getTvShowBaseFx,
})
export const getTvShowEpisodeFx = attach({
  effect: api.tvshows.getTvShowEpisodeBaseFx,
})
export const getTvShowEpisodeWithoutSeasonFx = attach({
  effect: api.tvshows.getTvShowEpisodeWithoutSeasonBaseFx,
})
export const getTvShowSeasonByIdBaseFx = attach({
  effect: api.tvshows.getTvShowSeasonByIdBaseFx,
})
